export default __webpack_public_path__ + "static/convergence-station-255fe30f31a8203def066fe68c75e5c2.svg";